var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-icon",class:{
    'c-icon--colorize': !_vm.keepColors,
    'c-icon--small': _vm.size === 'small',
    'c-icon--large': _vm.size === 'large'
  },domProps:{"innerHTML":_vm._s(require(("@/assets/icons/" + _vm.icon + ".svg")))}})}
var staticRenderFns = []

export { render, staticRenderFns }